import styled from "styled-components";

export const StyledLayoutItem = styled.div`
  position: relative;
  border: ${(props) =>
    props.$focused
      ? `1px dashed ${props.theme.colors.accent.normal}`
      : props.$hovered
      ? `1px dashed ${props.theme.colors.accent.dark}`
      : "0"};
`;

export const StyledLayoutItemImage = styled.img`
  width: ${(props) =>
    props.$item.type === "image" ? props.$item.style.width : "100%"};
  height: ${(props) =>
    props.$item.type === "image" ? props.$item.style.height : "100%"};
  max-height: ${(props) =>
    props.$item.type === "image" ? props.$item.style.maxHeight : "100%"};
  max-width: ${(props) =>
    props.$item.type === "image" ? props.$item.style.maxWidth : "100%"};
  object-fit: cover;
  position: ${(props) =>
    props.$item.type === "image" ? "initial" : "absolute"};
  top: 0;
  left: 0;
`;

export const StyledLayoutItemBcCompany = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  width: 100%;
  height: 100%;

  & div {
    width: 100%;
    flex: 1;
    overflow: hidden;
  }

  & img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

  & p {
    margin-block: ${(props) => props.theme.spacing.normal};
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    padding-inline: ${(props) => props.theme.spacing.normal};
    text-align: center;
  }
`;
